import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Reviews } from 'features/Reviews'
import Script from 'next/script'
import { useReviews } from 'hooks/useReviews'
import { extractLettersAndWhitespace } from 'utils/extractLettersAndWhitespace'

export default function RecipesPage() {
  const { t } = useTranslation()
  const reviews = useReviews()

  const reviewsSchema = reviews.map((review) => {
    return { 
      "@type": "Review",
      "reviewBody": t(review.comment),
      "author": {
        "@type": "Person",
        "name": extractLettersAndWhitespace(t(review.owner)) 
      },
    }
  })

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "We Feed Raw Dog Food Reviews",
    "url": "https://wefeedraw.com/reviews",
    "description": "Excellent quality, customer service, and delivery. Transformative results in as little as one week! See what others are saying about the magic of raw.",
    "brand": {
      "@type": "Brand",
      "name": "We Feed Raw"
    },
    "review": reviewsSchema,
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "844", 
      "author": {
        "@type": "Organization",
        "name": "Trustpilot"
      }
    }
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('reviews:page-title')}</title>
        <meta name="title" content={t('reviews:meta-title')} />
        <meta name="description" content={t('reviews:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/reviews" />
      </Head>

      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />

      <main>
        <Reviews />
      </main>
    </div>
  )
}